<script setup lang="ts">
    import { Check } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        AlertDialog,
        AlertDialogTrigger,
        AlertDialogContent,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogCancel,
        AlertDialogAction,
    } from '@/components/ui/alert-dialog';
    import { useI18n } from 'vue-i18n';
    import { router } from '@inertiajs/vue3';
    import { toast } from 'vue-sonner';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';
    import { computed } from 'vue';
    
    const queryClient = useQueryClient();

    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    const { t } = useI18n();

    const closePeriod = () => {
        router.post(
            route('v2.voucher.admin.close-period'),
            { company_id: companyId.value },
            {
                onSuccess: () => {
                    toast.success(t('vouchers.close_success'));
                    queryClient.invalidateQueries({ queryKey: [QueryKey.VOUCHERS, companyId.value] });
                },
                onError: (error) => {
                    toast.error(error.error);
                },
            },
        );
    };
</script>

<template>
    <AlertDialog>
        <AlertDialogTrigger as-child>
            <Button
                variant="ghost"
                width="narrow"
                class="self-start"
                size="xs"
            >
                {{ t('vouchers.close_period') }}
                <Check class="text-accent" />
            </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{ t('vouchers.js.period_title') }}</AlertDialogTitle>
                <AlertDialogDescription>{{
                    t('vouchers.js.period_content')
                }}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>{{ t('forms.no') }}</AlertDialogCancel>
                <AlertDialogAction
                    variant="default"
                    @click="closePeriod"
                >
                    {{ t('forms.yes') }}
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
